import React from "react"; // eslint-disable-line no-unused-vars
import { Grid2 as Grid, TextField } from "@mui/material";
import { Donation, CodeDetails, Settings } from "../types";

export interface DonationMessageProps {
  settings: Settings;
  donation: Donation;
  handleChange: (donation: Donation) => void;
}

export const DonationMessage = ({
  settings,
  donation,
  handleChange,
}: DonationMessageProps): React.JSX.Element | null => {
  if (settings.enableTestimonials) {
    return (
      <Grid size={{ xs: 12 }}>
        <TextField
          fullWidth={true}
          multiline={true}
          rows={5}
          label="Tell us why you chose this charity."
          helperText="Your testimonials can help generate more support for this charity."
          value={donation.message}
          onChange={(
            event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
          ) => {
            handleChange({
              ...donation,
              message: event.target.value,
            });
          }}
        />
      </Grid>
    );
  } else {
    return null;
  }
};
